import { render, staticRenderFns } from "./CatalogueSort.vue?vue&type=template&id=a055c7ec"
import script from "./CatalogueSort.vue?vue&type=script&lang=js"
export * from "./CatalogueSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports